import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import Layout from './components/layout/Layout';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Clientes from './pages/Clientes';
import Notificaciones from './pages/Notificaciones';
import Tiendas from './pages/Tiendas';
import Diseno from './pages/Diseno';
import Niveles from './pages/Niveles';
import Usuarios from './pages/Usuarios';

function PrivateRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div style={{ display:'flex', alignItems:'center', justifyContent:'center', height:'100vh', color:'#888', fontFamily:'Barlow,sans-serif' }}>Cargando...</div>;
  return user ? <Layout>{children}</Layout> : <Navigate to="/login" replace />;
}

function AppRoutes() {
  const { user } = useAuth();
  return (
    <Routes>
      <Route path="/login" element={user ? <Navigate to="/" replace /> : <Login />} />
      <Route path="/"               element={<PrivateRoute><Dashboard /></PrivateRoute>} />
      <Route path="/clientes"       element={<PrivateRoute><Clientes /></PrivateRoute>} />
      <Route path="/notificaciones" element={<PrivateRoute><Notificaciones /></PrivateRoute>} />
      <Route path="/tiendas"        element={<PrivateRoute><Tiendas /></PrivateRoute>} />
      <Route path="/diseno"         element={<PrivateRoute><Diseno /></PrivateRoute>} />
      <Route path="/niveles"        element={<PrivateRoute><Niveles /></PrivateRoute>} />
      <Route path="/usuarios"       element={<PrivateRoute><Usuarios /></PrivateRoute>} />
      <Route path="*"               element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AppRoutes />
      </AuthProvider>
    </BrowserRouter>
  );
}
